﻿import buttonLoader from '../../utilities/buttonLoader.js';
import timetable_register from './timetableRegister.js';

let classRegister = {};

classRegister = {

  init: function () {

    const me = this;
    var form = document.getElementsByClassName('classRegisterForm')[0];

    if (form) {
      me.bind(form);
    }

  },

  bind: function (form) {
    const me = this;

    form.addEventListener('submit', function (e) {

      e.preventDefault();

      const m = form.querySelector('.alert');

      if (m) {
        m.remove();
      }

      me.submit(form);

    });

    const termCheckbox = document.getElementById('class__terms');

    if (termCheckbox) {
      termCheckbox.addEventListener('change', function (e) {

        const checked = e.target.checked;

        if (checked) {
          form.querySelector('button[type=submit]').removeAttribute('disabled');
        } else {
          form.querySelector('button[type=submit]').setAttribute('disabled', 'disabled');
        }

      });
    }


  },

  submit: function (form) {
    const me = this;
    const button = form.querySelector('button[type=submit]');

    buttonLoader.start(button);

    const data = new FormData(form);

    const xhr = new XMLHttpRequest();
    xhr.open(form.getAttribute("method"), form.getAttribute("action"));

    xhr.onload = function () {
      const resp = JSON.parse(xhr.response);

      if (xhr.status >= 200 && xhr.status < 300) {
        if (resp.success) {
          buttonLoader.success(button);

          const modal = document.getElementsByClassName('modal')[0];

          if (modal) {
            const itemId = form.querySelector('input[name=itemId]').value;

            const timeTablebutton = document.querySelector('button[data-itemId="' + itemId + '"]');

            timeTablebutton.querySelector('span').innerText = timeTablebutton.getAttribute('data-defaultUnsubscribe');
            timeTablebutton.classList.add('button--burgundy', 'action-unsubscribe-class');
            timeTablebutton.classList.remove('button--primary', 'action-register-class');

            const buttonClone = timeTablebutton.cloneNode(true);
            timeTablebutton.parentNode.replaceChild(buttonClone, timeTablebutton);

            timetable_register.Unsubscribe.bindClasses(buttonClone);

            modal.classList.remove('modal--show');
          }

        } else {

          buttonLoader.reset(button);

          me.renderMessage(button, resp.message, 'error');
        }

      } else {

        buttonLoader.reset(button);

        me.renderMessage(button, 'Server error', 'error');
      }

    };

    xhr.send(data);
  },

  renderMessage: function (el, message, type) {
    el.insertAdjacentHTML('beforebegin', '<div class="alert ' + type + '">' + message + '</div>');

  }
};


classRegister.initialize = function () {
  classRegister.init();
};

module.exports = classRegister;
